// extracted by mini-css-extract-plugin
module.exports = {"lia-description":"ToggleTextKeysFloatingBox_lia-description__KgOVM"};